<template>
  <div>
    <Toolbar :esDocumento="true" />
    <!-- <iframe
      id="pdf-iframe"
      :src="urlDocumento"
      style="width: 100%; height: 100vh"
    ></iframe> -->
    <vue-pdf-embed :source="urlDocumento" />
  </div>
</template>

<script>
import Toolbar from '@/components/compartidos/Toolbar.vue'
import { CONTRATO_DOC_URL } from '@/utilidades/utilidades'
import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed'
import { InsertaLogMixin } from '@/mixins/credito/InsertaLog.mixin'

export default {
  name: 'Contrato',
  components: {
    Toolbar,
    VuePdfEmbed,
  },
  mixins: [InsertaLogMixin],
  data: () => ({
    urlDocumento: '',
  }),
  mounted() {
    this.InsertaLog()
  },
  created() {
    this.$store.commit('ESTABLECER_LAYOUT', 'LayoutDocumento')
    this.urlDocumento = './' + CONTRATO_DOC_URL
  },
}
</script>

<style>
/*  */
</style>
